import React from 'react';
import { TranslateScope, Translate, useTranslate } from '@pegasus/translation';
import { Snackbar, SnackbarType } from '@lux/snackbar';
import { buildEmailProviderUri, getEmailProvider } from '@pegasus/overlays';
export const AutoLoginSuccessNotification = ({ isDOIUser, email, }) => {
    const translate = useTranslate();
    const provider = getEmailProvider(email);
    const targetUri = provider && buildEmailProviderUri(provider);
    return (React.createElement(TranslateScope, { path: "" },
        React.createElement(Snackbar, { type: SnackbarType.SUCCESS, content: React.createElement(Translate, { message: isDOIUser
                    ? 'autoLoginTooltip.newsletterSuccessTextDoi'
                    : 'autoLoginTooltip.newsletterSuccessText' }), visible: true, animateIn: true, action: isDOIUser &&
                targetUri && {
                text: translate('autoLoginTooltip.ctaDoi'),
                ctaCallback: () => {
                    window.location.href = targetUri;
                },
            } })));
};
//# sourceMappingURL=notification.js.map